<template>
	<div class="page-one report-share-page">
		<div class="report-back-box" @click="clickBack">
			<div class="report-back"></div>
		</div>
		<div v-if="!showImage" class="report-loading-text">{{loadingText}}</div>
		<div v-if="!showImage" class="report-capture-box" :style="'height: '+height+'px'">
			<div ref="capture" class="report-capture">
				<!-- 主要内容部分 -->
				<div class="report-capture-top-bar" :style="'height: '+height*0.9+'px'">
					<img class="report-capture-top-img-bg" :src="imageList[3]" alt="">
					<img class="report-capture-top-img-title" :src="imageList[4]" alt="">
					<img class="report-capture-top-img-cow" :src="imageList[5]" alt="">
					<div class="report-capture-top-img-popbg-box">
						<img class="report-capture-top-img-popbg" :src="imageList[6]" alt="">
						<img class="report-capture-top-img-light" :src="imageList[7]" alt="">
						<div class="report-capture-user-info">
							<img class="report-capture-user-avatar" :src="imageList[8]" alt="">
							<div class="report-capture-user-nickname">{{userPageData && userPageData.fName ? userPageData.fName : ''}}</div>
						</div>
						<div class="report-capture-top-img-score-box">
							<img class="report-capture-top-img-score" :src="imageList[9]" alt="">
							<div class="report-capture-top-score-box">
								<img class="report-capture-top-img-s-num num1" :src="imageList[10]" alt="">
								<img class="report-capture-top-img-s-num num2" :src="imageList[11]" alt="">
							</div>
							<span class="report-score">分</span>
						</div>
						<div class="report-capture-top-content">
							<img class="report-capture-top-content-bg" :src="imageList[12]" alt="">
							<div class="report-capture-top-content-p" v-if="userPageData.des">
								<p class="title1">{{userPageData.des[0]}}</p>
								<p class="title2">{{userPageData.des[1]}}</p>
							</div>
						</div>
					</div>
				</div>
				<!-- 二维码部分 -->
				<div class="report-capture-code-box dsp-flex" :style="'height: '+height*0.1+'px'">
					<div class="report-capture-code-mid">
						<div class="report-capture-code-mid-c">
							<img class="report-capture-code-logo" :src="imageList[0]" alt="">
							<div class="report-capture-code-note">长按二维码解析</div>
						</div>
					</div>
					<div class="report-capture-code-side">
						<img class="report-capture-code-img" :style="'width: '+height*0.1*0.95+'px; height: '+height*0.1*0.95+'px'" :src="imageList[2]" alt="">
					</div>
				</div>
			</div>
		</div>
		<div v-if="showImage" class="report-capture-img-box" :style="'height: '+imgHeight+'px'"></div>
		<div v-if="showImage" class="report-share-save" :style="'bottom:'+bottom+'px'"></div>
		<!-- <div class="report-share-button-box">
			<button class="report-share-button" @click="clickSaveImg">保存到手机相册</button>
		</div> -->
	</div>
</template>

<script>
	import { WEIXIN } from '../modules/weixin'
	import html2canvas from 'html2canvas'
	import { Canvas2Image } from '../modules/canvas/canvas2image'
	export default {
		computed: {
			userInfo() {
				return this.$store.state.userData.info;
			},
			userPageData() {
				return this.$store.state.user.userPageData;
			},
			gotUserPageData() {
				return this.$store.state.user.gotUserPageData;
			},
			sharePicAvatarImg() {
				return this.$store.state.res.sharePicAvatarImg;
			},
			sharePicImageList() {
				return this.$store.state.res.sharePicImageList;
			}
		},
		data() {
			return {
				loadingText: '正在生成图片中', loadingTime: 0, bottom: 100,
				showImage: false,
				height: 640, codeH: 0, imgHeight: 640,
				titleClass: 'aiguo',
				imageList: [
					'http://m1.2048.net/duoniu/images_rabbit/index/index-title.png',
					'http://m1.2048.net/duoniu/images_rabbit/report/code.png',
					'http://m1.2048.net/duoniu/images_rabbit/report/code.png'
				],
				avatarImg: 'http://m1.2048.net/duoniu/images_rabbit/avatar-rabbit.png'
			}
		},
		mounted() {
			setTimeout(function() {
				if(!this.gotUserPageData) {
					this.$router.replace('/home');
				}
				this.initDom();
				this.initBase64Image();
			}.bind(this), 20);
			setTimeout(function() {
				this.drawImage();
			}.bind(this), 3000);
		},
		methods: {
			initDom() {
				this.imgHeight = innerHeight;
				this.height = window.screen.height;
				var barDom = document.getElementsByClassName('report-capture-code-box')[0];
				this.bottom = barDom ? barDom.clientHeight : this.bottom;
				this.bottom = this.height >= 800 ? this.bottom+innerHeight*0.4 : this.bottom+innerHeight*0.3;
				// console.error('initDom------', barDom, this.bottom);
				var me = this;
				function ani() {
					if(me.loadingTime < 3) {
						me.loadingTime++;
						me.loadingText = me.loadingText+'.';
					}else {
						me.loadingTime = 0;
						me.loadingText = '正在生成图片中';
					}
					setTimeout(ani, 300);
				}
				ani();
			},
			initBase64Image() {
				var me = this,
					userInfo = this.$store.state.userInfo,
					avatarURL = this.avatarImg;
            	console.log('--------------', userInfo, avatarURL, this.userPageData);
				// 动态添加顶部一系列图片
				this.imageList.push('http://m1.2048.net/duoniu/images_rabbit/share/share-bg-'+this.userPageData.titleClass+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images_rabbit/cow/cow-t-'+this.userPageData.titleClass+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images_rabbit/cow/cow-'+this.userPageData.titleClass+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images_rabbit/cow/cow-bg-'+this.userPageData.titleClass+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images_rabbit/report/report-light.png');
				this.imageList.push(avatarURL);
				this.imageList.push('http://m1.2048.net/duoniu/images/cow/cow-sbg-'+this.userPageData.titleClass+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images/common/num-'+this.userPageData.scoreArr[0]+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images/common/num-'+this.userPageData.scoreArr[1]+'.png')
				this.imageList.push('http://m1.2048.net/duoniu/images/share/share-cbg.png');

				Promise.all(me.imageList.map((item) => me.getBase64(item))).then(function(resultURL) {
					me.imageList = resultURL;
				});
			},
			getBase64(url, outputFormat = 'image/png') {
				/** 获取base64的图片 */
				return new Promise(function (resolve, reject) {
					var img = new Image,
						canvas = document.createElement("canvas"),
						ctx = canvas.getContext("2d");
					img.crossOrigin = "Anonymous";
					img.onload = function() {
						canvas.width = img.width;
						canvas.height = img.height;
						ctx.drawImage( img, 0, 0 );
						var dataURL = canvas.toDataURL(outputFormat);
						canvas = null;
						resolve(dataURL);
					}
					img.src = url;
					//  确保缓存的图片也触发 load 事件
					if ( img.complete || img.complete === undefined ) {
						img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
						img.src = url;
					}
				});
			},
			clickBack() {
				this.$router.replace('/report')
			},
			drawImage() {
				var me = this,
                	captureDiv = this.$refs.capture,
                	width = captureDiv.offsetWidth, //获取dom 宽度
                	height = captureDiv.offsetHeight; //获取dom 高度
            	var canvas = document.createElement("canvas"); //创建一个canvas节点
            	var scale = 2;    //定义任意放大倍数 支持小数 1.065
                	canvas.width = width * scale; //定义canvas 宽度 * 缩放
                	canvas.height = height * scale; //定义canvas高度 *缩放
                	canvas.getContext("2d").scale(scale, scale); //获取context,设置scale 
				html2canvas(captureDiv).then(canvas => { 
					me.showImage = true;
					// console.log('保存图片url-----', canvas.toDataURL());
					var context = canvas.getContext('2d');
					// 【重要】关闭抗锯齿
					context.mozImageSmoothingEnabled = false;
					context.webkitImageSmoothingEnabled = false;
					context.msImageSmoothingEnabled = false;
					context.imageSmoothingEnabled = false;
					// 【重要】默认转化的格式为png,也可设置为其他格式
					var img = Canvas2Image.convertToPNG(canvas, canvas.width, canvas.height);
					console.log('保存图片---------', img, canvas.width, canvas.height);
					setTimeout(() => {
						var resultImage = document.getElementsByClassName('report-capture-img-box')[0];
							resultImage.innerHTML = '';
							resultImage.appendChild(img);
						var ratio = parseFloat(canvas.width / canvas.height);
						// console.log('--------', canvas.width, canvas.height, ratio, resultImage.clientHeight)
						var aW, aH;
							aH = resultImage.clientHeight; aW = resultImage.clientHeight * ratio;
						if(aW > resultImage.clientWidth) {
							aW = resultImage.clientWidth; aH = resultImage.clientWidth / ratio;
						}
						// console.log('aaaaaaa-----', aW, aH)
						// img.style.width = aW + 'px';
						// img.style.height = aH + 'px';
					}, 20);
				});
			}
		}
	}
</script>

<style>
</style>
